import { FilterableTableContractorImportBatches } from "../../components/TableContractorImportBatches/FilterableTableContractorImportBatches";
import { useBrowserPageTitle } from "../../../../shared/hooks/useBrowserPageTitle";

export const RouteImportContractors: React.FC = () => {
  useBrowserPageTitle("Bulk imports: Contractors");

  return <FilterableTableContractorImportBatches />;
};
